import { GREY_800, GREY_1000, Icons, SPACING_1_5 } from '@mnd-frontend/ui';
import styled from 'styled-components';

const AddButtonStyles = styled.button<{ $topMargin: string }>`
  background: none;
  border: 0;
  padding: 0;
  margin: ${({ $topMargin }) => $topMargin} 0 0;
  > span {
    display: flex;
    gap: ${SPACING_1_5};
    align-items: center;
    color: ${GREY_800};
    ${Icons.CirclePlus} {
      svg {
        color: ${GREY_1000};
      }
    }
  }
  font-size: 0.875rem;
  font-weight: 400;
`;

export const AddButton = ({
  topMargin = '1.5rem',
  onClick,
  disabled,
  testId,
  children,
}: {
  topMargin?: string;
  onClick: () => void;
  disabled?: boolean;
  testId: string;
  children: string;
}) => {
  return (
    <AddButtonStyles
      data-testid={testId}
      type="button"
      onClick={onClick}
      disabled={disabled}
      $topMargin={topMargin}
    >
      <span>
        <Icons.CirclePlus $size="sm" />
        <span>{children}</span>
      </span>
    </AddButtonStyles>
  );
};
